/**
 * Shown when the user’s city is not known yet (no geolocation / not detected /
 * user has not chosen a city). This is not a real place name.
 */
export const LOCATION_UNKNOWN_DISPLAY = "your location";
